import Vue from "vue";
import VueRouter from "vue-router";
import routerPermission from "@/router/permission";
import Layout from "@/views/Layout.vue";
/**
 * 路由配置项
 * name:''            // 设定路由的名字
 * meta : {
    privCode: ""            // 当前路由/菜单权限码（不设置该参数或者设置为空则表示当前页面无权限限制）
    title: ''               // 设置该路由在侧边栏和面包屑中展示的名字
    keepAlive: true/false   // 如果设置为true，则会被 <keep-alive> 缓存(不设置该参数或者设置为false则表示当前页面不会被缓存)
    noTagView:true/false //如果设置为true,则表示不显示在顶部页签
  }
 */
const routes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      noLogin: true,
    },
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/",
    // redirect:'/index'
  },
  {
    path: "/redirectIndex",
    meta: {
      noLogin: true,
    },
    component: () => import("@/views/RedirectIndex.vue"),
  },

  {
    path: "/index",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/list",
        name: "list",
        meta: {
          title: "首页",
        },
        component: () => import("@/views/listDemo.vue"),
      },
      {
        path: "/infoMaintain",
        name: "InfoMaintain",
        meta: {
          title: "信息披露维护",
        },
        component: () => import("@/views/InfoMaintain/index.vue"),
      },
      {
        path: "/infoMaintain/add",
        name: "InfoMaintainAdd",
        meta: {
          title: "新增信息披露",
          type: "add",
        },
        component: () => import("@/views/InfoMaintain/form.vue"),
      },
      {
        path: "/infoMaintain/edit",
        name: "InfoMaintainAdd",
        meta: {
          title: "编辑信息披露",
          type: "edit",
        },
        component: () => import("@/views/InfoMaintain/form.vue"),
      },
      {
        path: "/infoMaintain/detail",
        name: "InfoMaintainAdd",
        meta: {
          title: "信息披露维护详情",
          type: "view",
        },
        component: () => import("@/views/InfoMaintain/form.vue"),
      },
      {
        path: "/infoMaintain/list",
        name: "InfoMaintainList",
        meta: {
          title: "信息披露查看",
        },
        component: () => import("@/views/InfoMaintain/list.vue"),
      },
      {
        path: "/infoMaintainView/detail",
        name: "InfoMaintainViewAdd",
        meta: {
          title: "信息披露查看详情",
          type: "view",
        },
        component: () => import("@/views/InfoMaintain/form.vue"),
      },
      {
        path: "/infoMaintain/no-auth",
        name: "InfoMaintainNoAuth",
        meta: {
          title: "信息披露暂无权限",
        },
        component: () => import("@/views/InfoMaintain/NoAuth.vue"),
      },
      {
        path: "/test",
        name: "Test",
        meta: {
          title: "test",
        },
        component: () => import("@/views/listDemo.vue"),
      },
    ],
  },
  {
    path: "/nopriv",
    name: "NoAccess",
    meta: {
      noLogin: true,
    },
    component: () => import("@/views/NoAccess.vue"),
  },
  {
    path: "/404",
    name: "NoFound",
    meta: {
      noLogin: true,
    },
    component: () => import("@/views/NoFound.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];
const router = new VueRouter({
  routes: routes,
});
/* 添加全局路由守卫 */
routerPermission(router);
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
  }
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
export default router;
